export default function CTASection() {
  return (
    <section className="relative py-14 md:py-20 px-4 md:px-6 bg-background-100 overflow-hidden">
      {/* Background product images strip */}
      <div className="absolute inset-0 flex gap-3 md:gap-4 opacity-[0.06] pointer-events-none select-none">
        <div className="flex-shrink-0 w-48 h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20flat%20lay%20product%20photography%20of%20neutral%20tone%20clothing%20item%20on%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic&width=200&height=300&seq=cta-strip-1-2026-v5&orientation=portrait"
            alt=""
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 w-48 h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Minimalist%20sneaker%20product%20photography%20on%20warm%20beige%20surface%2C%20soft%20diffused%20daylight%2C%20clean%20editorial%20style%2C%20neutral%20tones&width=200&height=300&seq=cta-strip-2-2026-v5&orientation=portrait"
            alt=""
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 w-48 h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20accessories%20flat%20lay%20photography%20on%20cream%20linen%2C%20soft%20morning%20light%2C%20warm%20neutral%20aesthetic%2C%20minimalist%20composition&width=200&height=300&seq=cta-strip-3-2026-v5&orientation=portrait"
            alt=""
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 w-48 h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20bag%20product%20photography%20on%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style%2C%20warm%20beige%20tones&width=200&height=300&seq=cta-strip-4-2026-v5&orientation=portrait"
            alt=""
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 w-48 h-full">
          <img
            src="https://readdy.ai/api/search-image?query=Minimalist%20hoodie%20fashion%20photography%20on%20cream%20background%2C%20soft%20daylight%2C%20clean%20editorial%20style%2C%20warm%20neutral%20aesthetic&width=200&height=300&seq=cta-strip-5-2026-v5&orientation=portrait"
            alt=""
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight mb-4">
          Start Exploring the Latest AllChinaBuy Spreadsheet Today
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-7 max-w-lg mx-auto">
          Access 14 curated categories, trusted seller resources, verified QC photos, and expert buying guides — all in one organized place. Updated weekly.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-bold whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer"
          >
            AllChinaBuy Sheet
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-bold whitespace-nowrap hover:bg-foreground-800 transition-all cursor-pointer"
          >
            Buy It Now
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}